// In-memory access token + authenticated user, plus a minimal subscribe API
// so React components can re-render when either changes. The access token is
// deliberately kept out of localStorage / sessionStorage so it can't be read
// by other scripts; the refresh token lives in an HttpOnly cookie and is
// managed by the browser.

export type AuthUser = {
  id: string;
  email: string;
  name: string;
  role: "admin" | "user";
};

type Listener = () => void;

let accessToken: string | null = null;
let user: AuthUser | null = null;
const listeners = new Set<Listener>();

function emit(): void {
  for (const fn of listeners) fn();
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function getUser(): AuthUser | null {
  return user;
}

export function setSession(next: { accessToken: string; user: AuthUser }): void {
  accessToken = next.accessToken;
  user = next.user;
  emit();
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
  emit();
}

export function setUser(next: AuthUser | null): void {
  user = next;
  emit();
}

export function clearSession(): void {
  accessToken = null;
  user = null;
  emit();
}

export function subscribe(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
